import theme from 'utils/theme'

export const controlledRadioGroupStyles = {
  selected: {
    borderRadius: '8px',
    // @ts-ignore
    backgroundColor: theme.palette.secondary[50],
  },
}
